'use client';

import Script from 'next/script';

const RELEVANT_ID_SCRIPT_URL = '//d3op16id4dloxg.cloudfront.net/RelevantID4.js';

export const RVIDFormElements = [
    'ClientID',
    'SurveyID',
    'PanelistID',
    'GeoCodes',
    'PanelID',
    'RequestCSOData',
    'TimePeriod',
    'MembershipTenure',
    'VID',
    'CustomFactor',
];
interface RVIDFormProps {
    setWasRelevantIdScriptLoaded: (val: boolean) => void;
}

export const RVIDForm = ({ setWasRelevantIdScriptLoaded }: RVIDFormProps) => {
    return (
        <>
            <form name="RVIDform">
                {RVIDFormElements.map((elName) => (
                    <input type="hidden" id={elName} name={elName} key={elName} />
                ))}
            </form>
            <Script
                src={RELEVANT_ID_SCRIPT_URL}
                strategy="afterInteractive"
                onReady={() => setWasRelevantIdScriptLoaded(true)}
            />
        </>
    );
};
